import { useMatchMedia } from 'signer-app/utils/use-match-media';
import { useSignerContext } from 'signer-app/signer-experience/signer-experience';

export function useShouldShowDrawer() {
  const drawerSize = useMatchMedia('(max-width: 767px)');
  const { isMobileReady } = useSignerContext();
  return isMobileReady && drawerSize;
}
